module.exports = __webpack_public_path__ + "static/media/open cpu.c1149fe1.jpg";